import React, { useEffect, useContext } from 'react';
import GlobalContext from '../../context/Global/Context';
import setMixPanelEvent from '../../utils/setMixPanelEvent';
import PaymentMethod from '../PaymentMethod';
import Summary from '../Summary';
import styles from './Dashboard.module.css';

const Dashboard = () => {
  const globalContext = useContext(GlobalContext);
  const { country } = globalContext;

  useEffect(() => {
    setMixPanelEvent(country, 'Main Page View');
  }, []);

  return (
    <div className={styles.container}>
      <PaymentMethod />
      <Summary />
    </div>
  );
};

export default Dashboard;
